import axios from "axios";
import { BACKEND_URL } from "./Constants";
import { userReportsProfileMutation } from "./mutations";

export const REPORT_TYPE_MARRIED = "Married"

export const userReportsProfile = async(accessToken, report) => {
    
	// console.log('debug reporting person ', report.id);
	const response = await axios.post(
		BACKEND_URL,
		userReportsProfileMutation(accessToken, report)
	);
	// console.log('debug reported person', response.data);
	return response.data;
}